import Vue from 'vue';
import Vuex from 'vuex';
import Nav from '@/../public/static/nav.json';
import compact from 'lodash/compact';

import env from './modules/env.js';
import login from './modules/login.js';
import modal from './modules/modal.js';
import PushController from './modules/PushController.js';
import gapi from './modules/gapi.js';
import splash from './modules/splash.js';
import category from './modules/category';
import brandCategory from './modules/brandCategory';
import EventWinnerPick from './modules/EventWinnerPick.js';
import EventCommentList from './modules/EventCommentList.js';
import SPBoxProducts from './modules/SPBoxProducts';
import SPBoxGoods from './modules/SPBoxGoods';
import ProductController from './modules/ProductController';
import productList from './modules/productList.js';
import brandList from './modules/brandList.js';
import register from './modules/register.js';
import filter from './modules/filter.js';
import ads from './modules/ads.js';
import notice from './modules/notice.js';
import award from './modules/award.js';
import qna from './modules/qna.js';
import stamp from './modules/stamp.js';
import config from '../config';
import mission from './modules/mission.js';

Vue.use(Vuex);

const state = {
	activeSpinner: false,
	paths: {},
	nav: null,
	typeModel: null,
	hasHeaderTitle: false,
	headerTitle: '',
};

const mutations = {
	toggleSpinner(state, bool) {
		state.activeSpinner =
			typeof bool === 'boolean' ? bool : !state.activeSpinner;
	},
	paths(state, obj) {
		for (const key in obj) {
			const path = obj[key];
			state.paths[key] =
				`${path.indexOf('/:') > -1 ? path.split('/:')[0] : path}`;
		}
	},
	hasHeaderTitle(state, bool = false) {
		state.hasHeaderTitle = bool;
	},
	headerTitle(state, title = '') {
		state.headerTitle = title;
	},
	initNav(state) {
		const account = state.login;
		state.nav = Nav.data.filter(({ accessRight }) =>
			accessRight
				? compact(
						Object.keys(accessRight).map(key => {
							return key === 'adminLevel'
								? accessRight[key] >= account[key]
								: accessRight[key].includes(account[key]);
						})
					).length
				: true
		);
		state.typeModel = { 0: config.domain };
	},
};

export default new Vuex.Store({
	modules: {
		env,
		login,
		modal,
		PushController,
		gapi,
		splash,
		category,
		EventWinnerPick,
		EventCommentList,
		SPBoxProducts,
		SPBoxGoods,
		ProductController,
		productList,
		brandList,
		register,
		filter,
		ads,
		notice,
		qna,
		award,
		stamp,
		brandCategory,
		mission,
	},
	state,
	mutations,
});
